import Loader from "src/components/Loader";
import Icon from "src/components/field/utils/Icon";

interface HeaderItemProps {
	icon?: string;
	label?: string;
	active?: boolean;
	onChange: () => void;
	disabled?: boolean;
	loading?: boolean;
}

const HeaderItem = ({
	icon,
	label,
	active,
	onChange,
	disabled,
	loading,
}: HeaderItemProps) => {
	let className = " ";

	if (active) {
		className += " bg-dark text-white";
	} else {
		className += " bg-white text-dark";
	}

	if (disabled) {
		className += " opacity-30";
	} else {
		className += " cursor-pointer";
	}

	if (loading) {
		return <Loader />;
	}

	if (icon) {
		return <Icon onClick={onChange} {...{ icon, className }} />;
	}
	return <Icon.Text>{label}</Icon.Text>;
};

export default HeaderItem;
